export function asMultiValue<T>(value: T | T[] | undefined, strict = true) {
  if (typeof value === 'undefined') {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value;
  }

  if (strict) {
    return undefined;
  }

  return [value as T];
}

export function asSingleValue<T>(value: T | T[] | undefined, strict = true) {
  if (typeof value === 'undefined') {
    return undefined;
  }

  if (Array.isArray(value)) {
    if (strict) {
      return undefined;
    }

    return value[0];
  }

  return value as T;
}

export function replaceItem<T>(array: T[], index: number, item: T) {
  return [...array.slice(0, index), item, ...array.slice(index + 1)];
}
